import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl, FormattedDate, FormattedNumber } from 'react-intl';
import { Grid, Row, Col, Button, Table, OverlayTrigger, Tooltip, Overlay, Label } from 'react-bootstrap';
import ScrollArea from 'react-scrollbar';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import moment from 'moment';
import 'moment-timezone';
import { includes as _includes, get as _get, isEmpty as _isEmpty } from 'lodash';

class RadCarList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shownIndex: null,
    };
  }

  handleClick = vin => {
    // console.log('handleClick vin', vin);
    if (this.props.onSelect) {
      this.props.onSelect(vin);
    }
  };

  render() {
    const { intl, projectConfig, carList, user, selectedCarList } = this.props;
    const { shownIndex } = this.state;
    const messages = intl.messages;

    let tBody = [];
    if (carList.length) {
      tBody = carList.map((car, i) => {
        const selectedCarStyle = {
          background: _includes(selectedCarList, _get(car, 'car._id')) ? '#fef6dd' : '',
        };

        return (
          <tr
            class={_includes(selectedCarList, _get(car, 'car._id')) ? 'shown' : ''}
            key={i}
            onClick={() => {
              this.handleClick(_get(car, 'car._id'));
            }}
          >
            <td style={selectedCarStyle}>{_get(car, 'car.licensePlate')}</td>
            <td style={selectedCarStyle}>{_get(car, 'car.carDescription')}</td>
            <td style={selectedCarStyle} class="text-right">
              {car.count}
            </td>
            <td style={selectedCarStyle} class="text-right">
              <FormattedNumber value={car.sum} style="currency" currency={projectConfig.data.currency} />
            </td>
            <td style={selectedCarStyle}>
              {_isEmpty(car.vehicle_registration_date) ? (
                '-'
              ) : (
                <FormattedDate
                  value={new Date(moment.tz(car.vehicle_registration_date, 'UTC').tz(user.profile.timezone))}
                />
              )}
            </td>
            <td style={selectedCarStyle}>
              <FormattedNumber
                value={car.days_booked / car.days_available}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
                style="percent"
              />
            </td>
          </tr>
        );
      });
    }

    /* if (shownIndex !== null) {
      // user wants to see details of a business
      tBody.splice((shownIndex+1), 0, (
        <RadcarDetails data={carList[shownIndex]} colSpan={10} key="carDetails" />
      ))
    } */

    return (
      <ScrollArea
        speed={0.8}
        className=""
        contentClassName=""
        horizontal={false}
        style={{ overflow: 'hidden', height: '445px' }}
      >
        <Table responsive hover condensed class="dataTable">
          <thead>
            <tr>
              <th>Kennzeichen</th>
              <th>Fahrzeug</th>
              <th class="text-right">Buchungen</th>
              <th class="text-right">Ertrag</th>
              <th>Zulassung</th>
              <th>Auslastung</th>
            </tr>
          </thead>
          <ReactCSSTransitionGroup
            transitionName="tablerows"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={1}
            component="tbody"
          >
            {tBody}
          </ReactCSSTransitionGroup>
        </Table>
      </ScrollArea>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    projectConfig: state.data.projectConfig,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(RadCarList));
